export const AUTOMATIC_CONFIG_VI = {
  automaticProcurementConfigManagement: 'Cấu hình tự động mua hàng',
}
